import React, { useState } from 'react';
import axios from 'axios';
import { Button, Form, Alert, Spinner, ListGroup } from 'react-bootstrap';
import BASE_URL from '../config'; // Import your BASE_URL


const DeleteEmail = () => {
  const [email, setEmail] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleDelete = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter an email address');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    setResults([]);
    
    try {
      const response = await axios.get(`${BASE_URL}api/proxy/delete-email`, {
        params: { email }
      });
      
      setResults(response.data.results);
      
      if (response.data.success) {
        setSuccess(`Successfully processed deletion for ${email}`);
      } else {
        setSuccess(`No deletions were needed for ${email}`);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete email');
    } finally {
      setLoading(false);
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'deleted':
      case 'added':
        return 'success';
      case 'not_found':
      case 'exists':
        return 'secondary';
      case 'error':
        return 'danger';
      default:
        return 'light';
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-lg">
        <div className="card-body">
          <h2 className="text-center mb-4">Delete Email from Databases</h2>
          
          <Form onSubmit={handleDelete} className="mb-4">
            <Form.Group controlId="emailDelete" className="mb-3" style={{ maxWidth: '400px' }}>
              <Form.Label>Enter Email Address to Delete:</Form.Label>
              <div className="d-flex">
                <Form.Control
                  type="email"
                  placeholder="Enter email to delete"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Button 
                  variant="danger" 
                  type="submit" 
                  className="ms-2" 
                  disabled={loading}
                >
                  {loading ? <Spinner animation="border" size="sm" /> : 'Delete'}
                </Button>
              </div>
            </Form.Group>
          </Form>

          {error && <Alert variant="danger">{error}</Alert>}

          {results.length > 0 && (
            <div className="mt-4">
              <h5>Deletion Results:</h5>
              <ListGroup>
                {results.map((result, index) => (
                  <ListGroup.Item 
                    key={index} 
                    variant={getStatusStyle(result.status)}
                  >
                    <strong>{result.database}.{result.table}:</strong> {result.message}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteEmail;